import { render, staticRenderFns } from "./PMDashboard.vue?vue&type=template&id=adf32fb8&scoped=true&"
import script from "./PMDashboard.vue?vue&type=script&lang=js&"
export * from "./PMDashboard.vue?vue&type=script&lang=js&"
import style0 from "./PMDashboard.vue?vue&type=style&index=0&id=adf32fb8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adf32fb8",
  null
  
)

export default component.exports